<app-breadcrumb [master]="'Marketing'" [parentName]="'Pola dodatkowe'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Dane">
    <app-additional-fields-details-view *ngIf="!modify" [additionalField]="additionalField" (modifyClicked)="modify = true"></app-additional-fields-details-view>
    <app-additional-fields-add *ngIf="modify" [additionalField]="additionalField" (closeModification)="modify = false; loadAdditionalField()"></app-additional-fields-add>
  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [additionalField]="additionalField"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
